import { matchPath } from 'react-router-dom';

export const matchRouteNotStrict = (path: string) =>
  matchPath({ path, end: false }, window.location.pathname);
